import './branding.css';

export const WESSAL_BRANDING = Object.freeze({
  productName: 'Wessal',
  extension: Object.freeze({
    mountPath: '/wessal',
    apiPath: '/wessal-api',
    bootstrapPath: '/wessal-api/v1/panel/bootstrap',
  }),
  documentMarker: 'active',
} as const);

export type WessalBranding = typeof WESSAL_BRANDING;

/**
 * Installs presentation-only metadata. Server-provided installation config is
 * still authoritative for names, logos, links, and account access.
 */
export const installWessalBranding = (target: Document = document) => {
  target.documentElement.dataset.wessalBrand = WESSAL_BRANDING.documentMarker;

  let applicationName = target.head.querySelector<HTMLMetaElement>(
    'meta[name="application-name"]'
  );

  if (!applicationName) {
    applicationName = target.createElement('meta');
    applicationName.name = 'application-name';
    target.head.append(applicationName);
  }

  applicationName.content = WESSAL_BRANDING.productName;
};
